module.exports = __webpack_public_path__ + "static/media/arrowSingle.svg";